<template>
  <ContainerBox title="部队资讯">
    <div class="team-info">
      <div class="base-desc">
        <BorderBg />
        <div class="title">
          {{ dataSource.name.value }}
        </div>
        <div class="desc">
          {{ dataSource.desc.value }}
        </div>
      </div>
      <div class="list">
        <div class="scroll-wrapper" ref="scroll">
          <div class="scroll-content">
            <template v-for="key in Object.keys(dataSource.member)">
              <a
                class="item"
                :key="key"
                :href="dataSource.member[key].link.value"
                v-if="dataSource.member[key].cover.hasValue && dataSource.member[key].cover.value"
                target="_blank"
              >
                <img class="cover" :src="dataSource.member[key].cover.value" alt="" />
                <div class="name">
                  {{ dataSource.member[key].name.value }}
                  <!-- <TextSlider :text="dataSource.member[key].name.value" :duration="5"></TextSlider> -->
                </div>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </ContainerBox>
</template>

<script>
import BScroll from "@better-scroll/core";
// components
import TextSlider from "@/components/TextSlider";
import ContainerBox from "./containerBox.vue";
import BorderBg from "./borderBg.vue";

export default {
  name: "TeamInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { ContainerBox, BorderBg, TextSlider },
  data() {
    return {
      bs: null
    };
  },
  watch: {
    dataSource: {
      handler(val) {
        this.initBS();
      }
    }
  },
  mounted() {
    this.initBS();
  },
  methods: {
    initBS() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3
      });
    }
  }
};
</script>

<style lang="less" scoped>
.team-info {
  padding-bottom: 20px;
  .base-desc {
    width: 100%;
    min-height: 40px;
    position: relative;
    padding: 22px 13px 16px;
    margin-bottom: 20px;

    .title {
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      line-height: 16px;
    }
    .desc {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 12px;
      color: rgba(51, 51, 51, 0.9);
      line-height: 16px;
      text-align: center;
    }
  }
  .list {
    width: 100%;
    padding: 0;
  }
  .scroll-wrapper {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    padding-bottom: 10px;
    .scroll-content {
      display: inline-block;
    }
    .item {
      position: relative;
      display: inline-block;
      width: 98px;
      height: 126px;
      margin-right: 8px;
      .cover {
        width: 100%;
      }
      .name {
        position: absolute;
        bottom: -16px;
        left: 0;
        width: 100%;
        font-weight: 500;
        font-size: 11px;
        color: #000000;
        text-align: center;
        padding: 0 6px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .link {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 24px;
        height: 24px;
        background: #1a88dd;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
